export default __webpack_public_path__ + "static/media/success.be6fc59c.svg";